import React from "react";

export const CalendarIcon = ({ isActive, ...props }: SvgIconProps) => {
  return (
    <svg width={13} height={14} viewBox="0 0 13 14" fill="none" {...props}>
      <path
        d="M10.6 2.2H2.2A1.2 1.2 0 001 3.4v8.4A1.2 1.2 0 002.2 13h8.4a1.2 1.2 0 001.2-1.2V3.4a1.2 1.2 0 00-1.2-1.2zM8.8 1v2.4M4 1v2.4M1 5.8h10.8"
        stroke={isActive ? "#ffff" : "#214160"}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
